import { useIntl } from 'react-intl';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockQuantity,
} from '../types';
import getMixedStatuses from '../util/getMixedStatuses';
import getSingleStock from '../util/getSingleStock';
import isSingleRestriction from '../util/isSingleRestriction';
import isSingleStock from '../util/isSingleStock';
import { singleStockMessageKey } from '../util/stockMessageKeys';
import useCurrentStockOnlyFlag from './useCurrentStockOnlyFlag';

const useStockMessage = ({
    stock,
    futureStock,
    restriction,
    desiredQuantity = 1,
}: {
    stock: StockQuantity | StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction?: ProductOrderRestriction | ProductOrderRestriction[];
    desiredQuantity?: number;
}) => {
    const intl = useIntl();
    const { store } = useStoreAndLanguageParams();
    const currentStockOnly = useCurrentStockOnlyFlag();

    if (
        restriction &&
        (isSingleRestriction(restriction)
            ? !!restriction.restrictionId
            : restriction.filter(item => !!item.restrictionId).length > 0)
    ) {
        return intl.formatMessage({
            id: singleStockMessageKey.restrictedForOrder,
        });
    }

    const messages = isSingleStock(stock)
        ? getSingleStock({
              store,
              stock,
              futureStock: futureStock.find(item => item.sku === stock.sku),
              desiredQuantity,
              currentStockOnly,
          })
        : getMixedStatuses({
              store,
              stock,
              futureStock,
              restriction: [],
              currentStockOnly,
          });

    return messages
        .filter(item => item.messageId)
        .map(item => {
            return intl.formatMessage({ id: item.messageId }, item.values);
        })
        .join(', ');
};

export default useStockMessage;
